import {
  alertsFetched,
  alertsRequestStarted,
  alertsRequestError,
  alertsCountRequestStarted,
  alertsCountFetched,
  alertsCountRequestError,
} from '../AlertsActions';
import AlertFetch from '../../../fetch/AlertFetch';
import { reportError } from './AppErrorThunk';
// CONSTANT
import { ALERTS_SEARCH_LIMIT } from '../../../Views/Alerts/AlertsConstants';

export function fetchAlerts(muns, criterias) {
  return function (dispatch) {
    dispatch(alertsRequestStarted(muns));
    const payload = {
      ...criterias,
      limit: ALERTS_SEARCH_LIMIT,
    };
    return AlertFetch.getAll(payload)
      .then((json) => {
        const newJson = {
          ...json,
          muns: muns,
          pageIndex: criterias.pageIndex,
          alertsSearchCriterias: criterias,
        };
        return newJson;
      })
      .then((json) => dispatch(alertsFetched(json)))
      .catch((error) => {
        dispatch(reportError(error));
        dispatch(alertsRequestError(error));
      });
  };
}

export function fetchAlertsCount(criterias = {}) {
  return function (dispatch) {
    dispatch(alertsCountRequestStarted());

    const payload = {
      ...criterias,
      limit: 0,
    };

    return AlertFetch.getAll(payload)
      .then((json) => {
        const alertsCount = json?.hits ?? 0;
        dispatch(alertsCountFetched(alertsCount));
      })
      .catch((error) => {
        dispatch(reportError(error));
        dispatch(alertsCountRequestError(error));
      });
  };
}
